import React from "react";


import s from "../componentsStlyes/SearchBar.module.css"



export default function SearchBar({handleInputChange,handleSubmit }){

    return(
        <div className='cont-searchbar'>
            <input onChange={(e)=> handleInputChange(e)} placeholder="Search recipes" type="text" />
            <button type="submit" onClick={(e) => handleSubmit(e)} className={s.searchBar}>Search</button>
        </div>
    )
}